import { Pipe, PipeTransform } from '@angular/core';
import { ProductSplashViewModel } from '@models/api-search.models';
import { ProductEncodeSplashesViewModel } from '@models/api.models';

@Pipe({
    name: 'getCampaignSplash',
    standalone: true
})
export class GetCampaignSplashPipe implements PipeTransform {
    /**
     * Transforms active splashes to encode splashes
     * @param activeSplashes
     * @param includeName
     */
    transform(
        activeSplashes?: ProductSplashViewModel[],
        includeName: string = 'campaign'
    ): ProductEncodeSplashesViewModel | undefined {
        if (!activeSplashes?.length) {
            return undefined;
        }

        const name = includeName ? includeName.toLowerCase() : 'campaign';
        const primarySplash = activeSplashes?.find(
            splash => splash.isPrimary && splash?.type?.toLowerCase().includes(name)
        );

        return primarySplash
            ? {
                  encodeId: primarySplash.id ?? '',
                  splashDescription: primarySplash.text,
                  ribbonColor: '437e89'
              }
            : undefined;
    }
}
